import { fabric } from "fabric";

export const CurvedText = fabric.util.createClass(fabric.IText, {
  initialize: function (text: string, options: any) {
    options || (options = {});
    this.callSuper("initialize", text, options);

    this.set({
      diameter: options.diameter || 200, // Diameter of the circle
      arcAngle: options.arcAngle || 360, // Angle covered by the arc
      startAngle: options.startAngle || 0, // Starting angle for the text
      isCurvedText: true, // Flag to identify curved text
    });

    this.updatePath();
  },

  calculatePath: function () {
    const diameter = this.get("diameter") || 300; // Circle diameter
    const radius = diameter / 2; // Convert diameter to radius
    const arcAngle = this.get("arcAngle") || 360; // Total arc angle for the text
    const startAngle = this.get("startAngle") || 0; // Starting angle for the text

    const charCount = this.text.length;
    if (charCount === 0) return; // No characters to render

    // Calculate the angle between each character
    const anglePerChar = arcAngle / (charCount - 1);

    // Adjust the start angle by adding 90° to align the starting point to the top
    let angle = startAngle + 90;

    // Calculate the position for the first character
    let mValueX = radius * Math.cos((angle * Math.PI) / 180);
    let mValueY = radius * Math.sin((angle * Math.PI) / 180);
    let pathString = `M ${mValueX} ${mValueY}`; // Start the path

    // Loop through each character to construct the arc
    for (let i = 0; i < charCount; i++) {
      const theta = (angle * Math.PI) / 180; // Convert angle to radians
      const xPos = radius * Math.cos(theta); // Calculate x position
      const yPos = radius * Math.sin(theta); // Calculate y position

      // Add an arc segment for the current character
      pathString += ` A ${radius} ${radius} 0 0 1 ${xPos} ${yPos}`;

      // Increment the angle for the next character
      angle += anglePerChar;
    }

    return pathString;
  },

  updatePath: function () {
    // Recalculate and update the path for the curved text
    let pathString = this.calculatePath();

    this.path = new fabric.Path(pathString);
    this.path.set({ visible: false }); // Hide the path itself
    this.set("path", this.path);
    this.setCoords(); // Update the object's bounding box
  },

  set: function (key: any, value: any) {
    this.callSuper("set", key, value);

    // Update the path if critical properties change
    if (key === "diameter" || key === "arcAngle" || key === "startAngle") {
      this.updatePath();
    }

    return this;
  },

  toObject: function (propertiesToInclude: string[] = []) {
    return fabric.util.object.extend(
      this.callSuper("toObject", propertiesToInclude),
      {
        diameter: this.get("diameter"),
        arcAngle: this.get("arcAngle"),
        startAngle: this.get("startAngle"),
        isCurvedText: this.get("isCurvedText"),
      }
    );
  },

  // override cacheProperties, to include the custom properties.
  // After cache fix in 5.5.1, this is needed.

  //@ts-ignore
  cacheProperties: fabric.IText.prototype.cacheProperties.concat([
    "diameter",
    "arcAngle",
    "startAngle",
    "isCurvedText",
  ]),
});
